module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/part2-teacher.9a8f1237.png";